import { render } from "./contact.vue?vue&type=template&id=9d9762b4"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/contact.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9d9762b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9d9762b4', __exports__)) {
    api.reload('9d9762b4', __exports__)
  }
  
  module.hot.accept("./contact.vue?vue&type=template&id=9d9762b4", () => {
    api.rerender('9d9762b4', render)
  })

}


export default __exports__